import { ITableColumn } from '../../table.interfaces'

const TablePublicColumn = (props: React.PropsWithChildren<ITableColumn>) => {
  const { children } = props

  return <>{children}</>
}

export default TablePublicColumn
